import makeUseGlobalClientState from 'ui-library/hooks/global-client-state/makeUseGlobalClientState';

const pendingVoiceToolInvocationState = makeUseGlobalClientState<Array<string>>([]);

/** Record a dispatched Voice tool call until the Benchling invocation settles. */
export function beginPendingVoiceToolInvocation(chatSessionId: string, callId: string): void {
  const pendingCallIds = pendingVoiceToolInvocationState.getState(chatSessionId);
  if (!pendingCallIds.includes(callId)) {
    pendingVoiceToolInvocationState.updateState(chatSessionId, [...pendingCallIds, callId]);
  }
}

/** Settle one dispatched Voice tool call without disturbing other outstanding calls. */
export function settlePendingVoiceToolInvocation(chatSessionId: string, callId: string): void {
  pendingVoiceToolInvocationState.updateState(
    chatSessionId,
    pendingVoiceToolInvocationState
      .getState(chatSessionId)
      .filter((pendingCallId) => pendingCallId !== callId)
  );
}

/** Subscribe the chat UI to the number of dispatched Voice calls still running. */
export function usePendingVoiceToolInvocationCount(chatSessionId: string): number {
  const [pendingCallIds] = pendingVoiceToolInvocationState.useGlobalClientState(chatSessionId);
  return pendingCallIds.length;
}

/** @internal Test-only non-reactive snapshot. */
export function getPendingVoiceToolInvocationCount(chatSessionId: string): number {
  return pendingVoiceToolInvocationState.getState(chatSessionId).length;
}

/** @internal Test-only reset. */
export function clearPendingVoiceToolInvocations(chatSessionId: string): void {
  pendingVoiceToolInvocationState.deleteState(chatSessionId);
}
